import React from "react";
import { Box, Typography, IconButton } from "@mui/material";

import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";

interface Props {
  title: string;
  subtitle: string;
  onEdit: () => void;
  onDelete: () => void;
}

const UtilityCard: React.FC<Props> = ({
  title,
  subtitle,
  onEdit,
  onDelete,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        py: 1.5,
      }}
    >
      <Typography
        sx={{
          fontSize: 14,
          fontWeight: 600,
          color: "#101828",
        }}
      >
        {title}

        <Typography
          component="span"
          sx={{
            ml: 0.5,
            fontSize: 12,
            color: "#98A2B3",
            fontStyle: "italic",
            fontWeight: 400,
          }}
        >
          {subtitle}
        </Typography>
      </Typography>

      <Box display="flex" alignItems="center">
        <IconButton
          size="small"
          onClick={onEdit}
          sx={{
            color: "#6941C6",
            "&:hover": {
              backgroundColor: "#F4EBFF",
            },
          }}
        >
          <EditOutlinedIcon fontSize="small" />
        </IconButton>

        <IconButton
          size="small"
          onClick={onDelete}
          sx={{
            color: "#D92D20",
            "&:hover": {
              backgroundColor: "#FEF3F2",
            },
          }}
        >
          <DeleteOutlineOutlinedIcon fontSize="small" />
        </IconButton>
      </Box>
    </Box>
  );
};

export default UtilityCard;
